import React, { useState } from "react";

const PermissionContext = React.createContext({
  permissions: [],
  setPermissions: () => { },
});

export const PermissionContextProvider = (props) => {
  const [permissions, setPermissions] = useState([]);

  return (
    <PermissionContext.Provider
      value={{ permissions: permissions, setPermissions: setPermissions }}
    >
      {props.children}
    </PermissionContext.Provider>
  );
};

export default PermissionContext;
